/**
 * Get the first name (first word) from a display name for sorting.
 * e.g. "David Stearns" -> "David", "Coach J" -> "Coach"
 */
export function getFirstName(displayName: string | undefined | null): string {
  if (displayName == null || typeof displayName !== 'string') return '';
  const first = displayName.trim().split(/\s+/)[0];
  return first ?? '';
}

/**
 * Sort an array by the first name (first word of display name).
 * Use for consistent alpha-by-first-name ordering of team/member lists app-wide.
 */
export function sortByFirstName<T>(items: T[], getDisplayName: (item: T) => string | undefined | null): T[] {
  return [...items].sort((a, b) =>
    getFirstName(getDisplayName(a)).localeCompare(getFirstName(getDisplayName(b)), undefined, { sensitivity: 'base' })
  );
}
